import { render } from "./About.vue?vue&type=template&id=a660e064&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=a660e064&scoped=true&lang=scss"

import exportComponent from "/builds/_flowern/janroedger/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@3.9.7__webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a660e064"]])

export default __exports__